import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map, shareReplay, take } from 'rxjs/operators';

import { LanguageLocalePair } from '@language';
import { ShAbstractHttpService } from '@stylehaven/components';

@Injectable({ providedIn: 'root' })
export class LocalesService {
    private readonly localesEndpoint: string = `v2/locales`;

    constructor(protected http: ShAbstractHttpService) {}

    public getLocales(): Observable<string[]> {
        return this.http.get<string[]>(this.localesEndpoint).pipe(take(1), shareReplay(1));
    }

    public getLanguageLocalePairs(): Observable<LanguageLocalePair[]> {
        return this.getLocales().pipe(map(locales => locales.map(locale => this.localeToLanguageLocalePair(locale))));
    }

    private localeToLanguageLocalePair(locale: string): LanguageLocalePair {
        const language = locale.split('_')[0];
        return { Language: language, Locale: locale } as LanguageLocalePair;
    }
}
